/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */
import { connect } from "react-redux"
import * as links from "../../util/links"
import { filterEventsWithPlaylist } from "../../util/playlistStore"
import moment from "moment"

import { ShareGameModal } from "./ShareGameModal"
import { SharePlayerModal } from "./SharePlayerModal"

export const nativeShareMoment = (game, playlist, event) => {
    let isMobile = false
    if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        )
    ) {
        isMobile = true
    }

    if (navigator.share && isMobile) {
        let url = window.location.href.replace("/#", "")
        url += "?mtm_campaign=gg"
        url += "&utm_kwd=native-share"

        let date = moment(game.date)
        let gameDate = date.format("MMMM Do, YYYY")

        let text = `${
            playlist ? playlist?.title : ""
        } playlist from match on ${gameDate}. #TraceMoments`

        navigator
            .share({
                text,
                url,
            })
            .then(() => {
                console.log("nativeShareMoment", "success")
            })
            .catch((err) => {
                console.log("nativeShareMoment", "failed", err)
            })
        return true
    }
    return false
}

const mapStateToProps = (state, props) => {
    let extras = links.getUrlExtras(window.location.hash)
    let teamName = props.match.params.team_name
    var playerId = extras.players
    let gameId = props.match.params.game_id
    let fullGameEventNumber = 1
    let fullGameTime = 0
    let isFullGame = false
    let game = state.game.value
    let team = state.team.value
    let user = state.user.value
    let event = state.video.value.source
    let currentPlaylist = null

    // player
    let player = undefined
    if (state.game.value) {
        for (let p of state.game.value.home_team.players) {
            if (p.trace_number === playerId) {
                player = p.user
                break
            }
        }
    }
    if (player === undefined) {
        player = {
            user: {
                first_name: "--",
                last_name: "--",
                id: playerId,
            },
        }
    }

    if (state.game.value) {
        let event = null
        let allEvents = state.game.value.events
        let playlists = state.game.value.playlists
        currentPlaylist = state.video.value.playlist
        if (currentPlaylist) {
            isFullGame = currentPlaylist.id === "full-game"
        }
        event = state.video.value.source
        if (event) {
            let hvo = 0
            for (let pl of playlists) {
                if (pl.id === "full-game") {
                    let fgEvents = filterEventsWithPlaylist(pl, allEvents)
                    for (let fge of fgEvents) {
                        if (event.half === fge.half) {
                            //console.log('share.event fge', fge)
                            hvo = fge.dynamic.start
                            fullGameEventNumber = fge.event_number
                        }
                    }
                }
            }
            fullGameTime = Math.round(
                event.dynamic.start - event.dynamic.offset - hvo
            )
        }
    }

    if (currentPlaylist === null) {
        currentPlaylist = { title: "", event_count: 0 }
    }

    let gameDate = ""
    if (game && game.date) {
        let date = moment(game.date)
        gameDate = date.format("MMMM Do, YYYY")
    }

    // mode
    let mode = "game"
    if (extras.players) {
        mode = "player"
    }
    //console.log('extras', player)

    return {
        player,
        extras,
        teamName,
        gameId,
        fullGameEventNumber,
        fullGameTime,
        isFullGame,
        currentPlaylist,
        gameDate,
        mode,
        game,
        user,
        team,
        event,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toast: (message) => {
            dispatch({ type: "TOAST", message: message })
        },
    }
}

export const ShareGame = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShareGameModal)
export const SharePlayer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SharePlayerModal)
